module.exports = __webpack_public_path__ + "img/productionBase_11.36b89ca0.png";